/**
 * VehicleRoadWorthyCheck actions
 */
export enum VehicleRoadWorthyCheckActionEnum {
	/**
	 * Set road worthy check status to approved
	 */
	APPROVE = 'approve',

	/**
	 * Set road worthy check status to active
	 */
	ACTIVATE = 'activate',

	/**
	 * Set road tax status to rejected
	 */
	REJECT = 'reject',

	/**
	 * Set road worthy check status to pending
	 */
	PENDING = 'make_pending',

	/**
	 * Set road worthy check status to expired
	 */
	EXPIRED = 'make_expired',

	/**
	 * Sumbit the paid amount of the road worthy check
	 */
	PAY = 'pay',

	/**
	 * Create maintenance record linked to the road worthy check
	 */
	CREATE_MAINTENANCE = 'create_maintenance',
}
